export default (suggestionText, term) => {
  return suggestionText.split(term).map((match) => {
    return (`<span class='autosuggest__highlighted-text'>${match}</span>`)
  }).join(`<span>${term}</span>`)
}



// WEBPACK FOOTER //
// ./client/components/autosuggest/highlightSearchTerm.js